<div class="airport-search-modal" cdkOverlayOrigin #origin="cdkOverlayOrigin">
  <ng-content></ng-content>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOpen]="isModalOpen"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOffsetY]="4"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayPanelClass]="
    isFullscreen
      ? 'airport-search-modal-mobile'
      : 'airport-search-modal-desktop'
  "
  (overlayOutsideClick)="closeModal()"
  (detach)="closeModal()"
>
  <!--adding data-design-system attribute here as 
we do not have this attribute on body tag for shop app-->
  <div
    id="airport-search-modal-container"
    class="airport-search-modal-container"
    data-design-system="delta-mach-1-light"
    [cdkTrapFocus]="isModalOpen"
  >
    <div class="airport-search-modal-header">
      <div class="airport-search-modal-title text-inverse">
        {{ predictiveSearchData.selectLabel }}
        {{ predictiveSearchData.placeholder }}
      </div>
      <img
        tabindex="0"
        class="airport-search-modal-close-icon"
        (click)="closeModal(true)"
        src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/close.svg"
        alt=""
        (keypress)="$event.key === 'Enter' && closeModal(true)"
      />
    </div>

    <div class="airport-search-modal-body">
      <div
        class="airport-search-modal-tabs"
        id="airport-search-modal-tabs-container"
      ></div>
      <ng-container
        *ngIf="getSelectedTabId() === 'search'"
        [ngTemplateOutlet]="predictiveSearchTemplate"
      ></ng-container>
      <ng-container
        *ngIf="getSelectedTabId() === 'recentSearch'"
        [ngTemplateOutlet]="recentSearchTemplate"
      ></ng-container>
      <ng-container
        *ngIf="getSelectedTabId() === 'savedSearch'"
        [ngTemplateOutlet]="savedSearchTemplate"
      ></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #predictiveSearchTemplate>
  <div class="predictive-search-container">
    <idp-predictive-search-mach-core
      [content]="predictiveSearchData"
      (choose)="handleChoose($event)"
      (valueChange)="handleValueChange($event)"
      (valueChangeOnInput)="valueChangeOnInputHandler()"
    ></idp-predictive-search-mach-core>
  </div>
</ng-template>

<ng-template #recentSearchTemplate>
  <div class="recent-search-container">
    <ul class="airport-list-container" role="listbox">
      <li
        *ngFor="let item of recentSearchList; index as i"
        class="airport-list-item"
        role="option"
        (click)="handleRecentOrSavedSearchItemClick('recent', i)"
      >
        <span>
          {{ item.label }}
        </span>
        <span *ngIf="!item.returnDate">
          {{ item.departureDate | date: 'MMM dd' }}
        </span>
        <span *ngIf="item.returnDate">
          {{ item.departureDate | date: 'MMM dd' }} -
          {{ item.returnDate | date: 'MMM dd' }}
        </span>
      </li>
    </ul>
  </div>
</ng-template>

<ng-template #savedSearchTemplate>
  <div class="saved-search-container">
    <ul class="airport-list-container" role="listbox">
      <li
        *ngFor="let item of savedSearchList; index as i"
        class="airport-list-item"
        (click)="handleRecentOrSavedSearchItemClick('saved', i)"
        role="option"
      >
        <span>{{ item }}</span>
      </li>
    </ul>
  </div>
</ng-template>
